import { Indicator, Root } from '@radix-ui/react-progress'
import styled from 'styled-components'

import type { Variant } from '../../../themes/types/commons.type'
import type { Height } from '../../../themes/types/width.type'

interface StyledProgressRootProps {
  $height: Height
  $variant: Variant
}

export const StyledProgressRoot = styled(Root)<StyledProgressRootProps>`
  position: relative;
  overflow: hidden;
  background-color: ${props => props.theme.colors[props.$variant].light};
  width: 100%;
  height: ${props => props.$height};
`

interface StyledProgressIndicatorProps {
  $max: number
  $variant: Variant
  $value: number
}

export const StyledProgressIndicator = styled(Indicator)<StyledProgressIndicatorProps>`
  background-color: ${props => props.theme.colors[props.$variant].base};
  width: 100%;
  height: 100%;
  transition: transform 660ms cubic-bezier(0.65, 0, 0.35, 1);
  transform: translateX(-${props => ((props.$max - props.$value) / props.$max) * 100}%);
`
